
import { Policy, Acknowledgment } from "@/types";
import { Dispatch, SetStateAction } from "react";

/**
 * Core policy operations for adding and updating policies
 */
export const usePolicyCore = (
  user: any,
  policies: Policy[],
  setPolicies: Dispatch<SetStateAction<Policy[]>>,
  acknowledgments: Acknowledgment[],
  setAcknowledgments: Dispatch<SetStateAction<Acknowledgment[]>>,
  saveToStorage: (updatedPolicies: Policy[], updatedAcknowledgments?: Acknowledgment[]) => void
) => {
  const addPolicy = (policy: Omit<Policy, "id" | "createdAt" | "updatedAt">, asDraft: boolean = false) => {
    const newPolicy: Policy = {
      ...policy,
      id: Math.random().toString(36).substr(2, 9),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      isDraft: asDraft
    };
    
    const updatedPolicies = [...policies, newPolicy];
    setPolicies(updatedPolicies);
    saveToStorage(updatedPolicies);
    
    // Return the new policy ID to allow for notifications, etc.
    return newPolicy.id;
  };

  return {
    addPolicy
  };
};
